import React, { Component } from 'react';
import { Button, Grid, Icon, Form, Tab, Loader, Label, Header, Message, Segment } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { withNamespaces } from '../i18n';
import _ from 'lodash';

class UserTabs extends Component {
	constructor(props) {
		super(props);
		let user = props.session.user;
		this.state = {
			showMe: false,
			token: user.emailToken,
			copied: false,
			gwtoken: user.token,
			loading: user.token || true,
		};
	}

	componentDidMount() {
		this.mounted = true;
		if (!this.state.gwtoken)
			fetch('/rest/user/token')
				.then(it => it.json())
				.then(data => {
					if (!this.mounted) return;
					this.setState({ gwtoken: data.gwtoken, loading: false, scopes: data.scopes || [] });
				})
				.catch(e => {
					if (!this.mounted) return;
					this.setState({ gwtoken: null, loading: false });
				});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	operation = () => {
		this.setState({
			showMe: !this.state.showMe,
		});
	};
	onCopy = () => {
		if (!this.state.copied) this.setState({ copied: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copied: false });
		}, 2000);
	};

	render() {
		const { t } = this.props;
		if (this.state.loading)
			return (
				<Tab.Pane attached={false}>
					<Loader active inline="centered" />
				</Tab.Pane>
			);
		return (
			<Tab.Pane attached={false}>
				<Header as="h4">
					<Icon name="key" />
					<Header.Content>{t('your_api_token')}</Header.Content>
				</Header>

				<Form>
					<Form.Input value={this.state.showMe ? this.state.gwtoken : this.state.gwtoken.replace(/./g, '*')} onChange={({ target: { value } }) => this.setState({ value, copied: false })} action>
						<input readOnly />
						<Button content={this.state.showMe ? t('hide') : t('show')} primary onClick={this.operation} />
						<CopyToClipboard text={this.state.gwtoken} onCopy={this.onCopy}>
							<Button icon color={this.state.copied ? 'teal' : undefined}>
								<Icon name={this.state.copied ? 'check' : 'copy'} />
								{t('copy')}
							</Button>
						</CopyToClipboard>
					</Form.Input>
				</Form>
				<Message>
					<Message.Header>{t('subscriptions')}</Message.Header>
					<Message.Content>{t('forsubs')+' '}{<a href='/auth/subscriptions'>{t('goto_subscriptions')}</a>}</Message.Content>
				</Message>
			</Tab.Pane>
		);
	}
}

export default withNamespaces()(UserTabs);
